import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHero from "@/components/layout/PageHero";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { HotelCard } from "@/components/home/FeaturedHotels";

const FILTERS = [
  { key: "all", label: "All Stays" },
  { key: "luxury", label: "Luxury" },
  { key: "budget", label: "Budget" },
  { key: "family", label: "Family Resorts" },
];

export default function Hotels() {
  const [hotels, setHotels] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => {
    const q = cat === "all" ? "" : `?category=${cat}`;
    api.get(`/hotels${q}`).then(({ data }) => setHotels(data)).catch(() => {});
  }, [cat]);

  return (
    <div data-testid="hotels-page">
      <PageHero
        kicker="Find Hotels"
        title="Hotels for every kind of trip"
        subtitle="Compare prices from Booking.com, Agoda, MakeMyTrip and other trusted partners — and book at the lowest rate."
      />
      <div className="container-page py-10">
        <Breadcrumbs items={[{ label: "Hotels" }]} />
        <div className="flex flex-wrap gap-2 mb-6">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              onClick={() => setCat(f.key)}
              data-testid={`hotel-filter-${f.key}`}
              className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${
                cat === f.key
                  ? "bg-brand text-white border-brand"
                  : "bg-white text-slate-700 border-slate-200 hover:border-brand"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotels.map((h) => <HotelCard key={h.id} hotel={h} />)}
        </div>
      </div>
    </div>
  );
}
